import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=0dbaaf49&scoped=true&"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=0dbaaf49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbaaf49",
  null
  
)

export default component.exports